module.exports = __webpack_public_path__ + "static/media/20170617-200029-009.2c763bb2.png";